import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { formatValue } from '@ts-core/utils/dataTableUtils';

import Table, { DateTableCell } from '@ts-core/components/Table';

const StudentMediaItemStatsTable = (props) => {
  const intl = useIntl();
  const { onFetchStats, onGetXlsxData, mediaStats, loading, error } = props;
  const { sessions = [], media, student } = mediaStats;

  const columns = useMemo(
    () => [
      {
        Header: intl.formatMessage({
          id: 'student.mediaItemStatsTable.startedAt',
        }),
        accessor: 'createdAt',
        valueTransformer: (value) => <DateTableCell date={value} />,
      },
      {
        Header: intl.formatMessage({
          id: 'student.mediaItemStatsTable.lastEvent',
        }),
        accessor: 'lastEventDate',
        valueTransformer: (value) => <DateTableCell date={value} />,
      },
      {
        Header: intl.formatMessage({
          id: 'student.mediaItemStatsTable.platform',
        }),
        accessor: 'platform',
        id: 'platform',
        filterable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.maxProgress' }),
        accessor: 'progressPercentage',
        valueTransformer: (value) => formatValue(value, 1),
        sortable: true,
      },
      {
        Header: intl.formatMessage({
          id: 'student.mediaItemStatsTable.skipped',
        }),
        accessor: 'skipProgress',
        id: 'skipProgress',
        filterable: true,
        valueTransformer: (value) =>
          intl.formatMessage({
            id: value ? 'button.yes.title' : 'button.no.title',
          }),
      },
    ],
    [intl]
  );

  return (
    <Table
      title={media?.name}
      data={sessions || []}
      columns={columns}
      loading={loading}
      errorMessage={error}
      onRefreshData={onFetchStats}
      allowDownloadAsXLSX
      xlsxFileName={`${student?.name} - ${media?.name}`}
      getDataToExport={onGetXlsxData}
    />
  );
};

StudentMediaItemStatsTable.propTypes = {
  onFetchStats: PropTypes.func,
  onGetXlsxData: PropTypes.func,

  mediaStats: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

StudentMediaItemStatsTable.defaultProps = {
  onFetchStats: undefined,
  onGetXlsxData: undefined,

  mediaStats: {},
  loading: false,
  error: undefined,
};

export default StudentMediaItemStatsTable;
